'use client';

import {
  HomeLandingSections,
  HomeStoriesSection,
  HomeCommunitySection,
  HomeVoicesSection,
  HomeAboutSection,
  CommunityMatrimonyServices,
} from '@/components/homePageSections';

import { useState } from 'react';
import Header from '@/components/Header';
import HomeHeroSection from '@/components/HomeHeroSection';

const communityServices: { label: string; href?: string }[] = [
  { label: "Leva Patil" },
  { label: "Leva Patil matrimony" },
  { label: "Leva Patil Caste" },
  { label: "Leva Patil brides" },
  { label: "Difference between Leva Patil and Maratha" },
  { label: "Leva Patil matrimony whatsapp group" },
  { label: "Leva Patil matrimony Jalgaon" },
  { label: "Leva Patil Jalgaon" },
  { label: "Leva Patil Vadhu Var Suchi" },
  { label: "Leva Patil matrimony Pune" },
  { label: "Leva Patil symbol" },
  { label: "Leva Patil Suchi Jalgaon" },
  { label: "Leva Patil matrimony &gt; Pune" },
  { label: "Leva Patil whatsapp group" },
  { label: "Leva Patil Samaj Nashik" },
  { label: "Leva Patil history in Marathi" },
  { label: "Leva Patil Suchi" },
  { label: "Are Leva Patil Kshatriya" },
  { label: "Leva Patil caste details in Marathi" },
  { label: "Leva Patil grooms" },
  { label: "Leva Patil grooms in USA" },
  { label: "Leva Patil Vadhu Var Suchi 2026 PDF Download" },
  { label: "Leva Patil Vadhu Var Melava Jalgaon" },
  { label: "Leva Patil Vadhu Suchi Jalgaon 2026" },
  { label: "Leva Patil Vadhu Var Suchak Mandal Pune" },
  { label: "लेवा पाटील समाज इतिहास" },
];

export default function LevaPatilClient() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  const faqItems = [
    { question: 'Which is the best Leva Patil matrimony?', answer: 'Marathivadhuvarsuchak.com is the most trusted Leva Patil matrimony in Maharashtra.' },
    { question: 'Which is the best Vadhu Var Suchak for Leva Patil caste?', answer: 'Marathivadhuvarsuchak.com is the best Vadhu Var Suchak for Leva Patil caste in Maharashtra state.' },
    { question: 'How to search Leva Patil brides online?', answer: 'Register free through Marathivadhuvarsuchak.com to search Leva Patil bride profiles online.' },
    { question: 'Which is the best Leva Patil matrimony Jalgaon?', answer: 'Marathivadhuvarsuchak.com is the best Leva Patil matrimony for Jalgaon, Nashik region.' },
    { question: 'Which is the trusted Leva Patil Jalgaon Matrimony?', answer: "'Marathi Vadhu Var Suchak' is the most trusted Leva Patil Matrimony for Jalgaon based Vadhu Var." },
    { question: 'How to search Leva Patil Vadhu Var Suchi?', answer: 'Register free on Marathivadhuvarsuchak.com to search Leva Patil Vadhu Var Suchi online.' },
    { question: 'Which is the best Leva Patil Matrimony Pune?', answer: 'Marathivadhuvarsuchak.com portal is the best Leva Patil Matrimony for Pune based Vadhu Var.' },
    { question: 'How to search trusted Leva Patil Suchi Jalgaon?', answer: 'To search trusted Leva Patil Suchi from Jalgaon, visit Marathivadhuvarsuchak.com Marathi matrimonial site.' },
    { question: 'How to search Leva Patil Samaj Nashik Vadhu Var?', answer: 'To search Leva Patil Samaj Nashik based Vadhu Var, register free on Marathivadhuvarsuchak.com Marathi matrimony site.' },
  ];

  return (
    <div className="bg-white">
      <Header variant="transparent" />

      <HomeHeroSection
        title="लेवा पाटील समाजातील वधू-वरांसाठी"
        subtitle="महाराष्ट्रातील अग्रणी विवाहसंस्था"
        trackingSource="leva_patil"
      />

      <HomeLandingSections />

      <HomeStoriesSection />

      <HomeCommunitySection />

      <HomeVoicesSection />

      <HomeAboutSection />

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Frequently Asked Questions</h2>
          <div className="max-w-4xl mx-auto">
            <div className="space-y-4">
              {faqItems.map((faq, index) => (
                <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                  <button
                    onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                    className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                  >
                    <h3 className="text-lg font-semibold text-gray-900">{faq.question}</h3>
                    <svg className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${openFAQ === index ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div className={`px-6 transition-all duration-300 ease-in-out ${openFAQ === index ? 'pb-4 max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'}`}>
                    <div className="text-gray-600 leading-relaxed py-3">
                      <p className="mb-3">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CommunityMatrimonyServices
        title="Leva Patil Vadhu Var for Leva Patil Samaj"
        items={communityServices}
      />

    </div>
  );
}
